const crud = { c: false, r: false, u: false, d: false };

export const mappings = Object.freeze({
  mapping: { ...crud },
  runIngestion: { ...crud },
});
